// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-breadcrumb[data-v-566d67d0]{padding:20px 5px;background:transparent}.h-view[data-v-566d67d0]{height:calc(100vh - 115px)}.max-avue-main[data-v-566d67d0]{width:100%!important;left:0}", ""]);
// Exports
module.exports = exports;
